import styled from 'styled-components';

export const InitialsStatusBadgeStyles = styled.div`
	position: relative;

	.icon {
		position: absolute;
		left: 80%;
		top: 0;
		width: 1rem;
		height: 1rem;
		background: ${({ theme }) => theme.v3.colors.white[0]};
		border-radius: 50%;
	}
`;
